import React from "react";
import Latex from "react-latex-next";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";
import GraphViewer from "../../components/GraphPlotter/GraphViewer";

export default function LinesPositionPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>W zadaniach maturalnych rozpoznajemy przede wszystkim proste równoległe.</p>
      <p>Dla postaci kierunkowej <InlineMath math="y=ax+b" /> porównujemy współczynniki kierunkowe:</p>
      <BlockMath math={String.raw`a_{1}=a_{2}`} />
      <p>Dla postaci ogólnej korzystamy bezpośrednio ze wzoru z karty wzorów:</p>
      <BlockMath math={String.raw`A_{1}B_{2}-A_{2}B_{1}=0`} />
      <p>Gdy mamy punkt, przez który ma przechodzić szukana prosta, po wyznaczeniu jej współczynnika <InlineMath math="a" /> podstawiamy współrzędne punktu do równania <InlineMath math="y=ax+b" /> i obliczamy <InlineMath math="b" />.</p>
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Parametr w postaci kierunkowej",
      description: <Latex>{`Dla jakiej wartości $m$ proste $y=(2m-1)x+3$ i $y=5x-2$ są równoległe?`}</Latex>,
      content: <><BlockMath math={String.raw`2m-1=5`} /><BlockMath math={String.raw`2m=6`} /><BlockMath math={String.raw`m=3`} /></>,
    },
    {
      label: "Przykład 2",
      summary: "Prosta równoległa przez punkt",
      description: <>Wyznacz prostą równoległą do <InlineMath math={String.raw`y=\frac{2}{3}x+1`} />, przechodzącą przez <InlineMath math="P=(3,4)" />.</>,
      content: (
        <div className="space-y-2">
          <BlockMath math={String.raw`a=\frac{2}{3}`} />
          <BlockMath math={String.raw`4=\frac{2}{3}\cdot3+b`} />
          <BlockMath math={String.raw`b=2`} />
          <BlockMath math={String.raw`y=\frac{2}{3}x+2`} />
          <div style={{ maxWidth: "350px", margin: "16px auto" }}>
            <GraphViewer
              equations={[{ expr: "(2/3)*x + 1", color: "#ff8c1a" }, { expr: "(2/3)*x + 2", color: "#9d4edd" }]}
              points={{ P: { x: 3, y: 4, label: "P", color: "#cc5500", textColor: "#cc5500" } }}
              config={{ xmin: -6, xmax: 6, ymin: -6, ymax: 6 }}
              height={350}
            />
          </div>
        </div>
      ),
    },
    {
      label: "Przykład 3",
      summary: "Parametr w postaci ogólnej",
      description: <Latex>{`Dla jakiej wartości $m$ proste $(m+2)x+3y-4=0$ oraz $4x+6y+1=0$ są równoległe?`}</Latex>,
      content: <>
        <BlockMath math={String.raw`A_{1}B_{2}-A_{2}B_{1}=0`} />
        <BlockMath math={String.raw`(m+2)\cdot6-4\cdot3=0`} />
        <BlockMath math={String.raw`6m+12-12=0`} />
        <BlockMath math={String.raw`6m=0`} />
        <BlockMath math={String.raw`m=\frac{0}{6}=0`} />
      </>,
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
